module.exports = __webpack_public_path__ + "img/rank4.b9448ea8.png";